import AUDIO from './uploadAudio.svg'
import VIDEO from './uploadVideo.svg'
import UPLOAD from './uploadFile.svg'

export default {
  AUDIO,
  VIDEO,
  UPLOAD
}